import {createContext} from "react";

export const GuildContext = createContext({
  id: null,
});
